module.exports = __webpack_public_path__ + "media/images/LaChakrita-965fdb6521fd3081eb09f9f4a02ab2db.png";